<script lang="ts">
  import Text from "./Text.svelte";

  export let date: Date;
  export let text: string | number;
  export let valid: boolean;
  export let disabled: boolean;
  export let selected: boolean;
  export let isFirst: boolean;
  export let isLast: boolean;
  export let didSelect: (date: Date) => void;

  function handleClick() {
    if (valid && !disabled) {
      didSelect(date);
    }
  }
</script>

<div class="outer">
  <div class="mask" class:show-mask={selected && !isFirst} />
  <div
    class="container"
    class:cursor-oversized={!disabled}
    class:inactive={!valid}
    class:disabled
    class:selected
    class:round-left={isFirst}
    class:round-right={isLast}
    on:click={handleClick}
  >
    {#if valid}
      <Text size="small">{text}</Text>
    {:else}
      <Text size="small" />
    {/if}
  </div>
  <div class="mask" class:show-mask={selected && !isLast} />
</div>

<style>
  .outer {
    display: flex;
    flex: 1;
    justify-content: stretch;
    align-items: stretch;
  }

  .mask {
    flex: 1;
    background-color: "transparent";
    z-index: -1;
  }

  .show-mask {
    background-color: var(--rekki-dark);
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
  }

  .disabled {
    color: var(--rekki-transparency-dark);
  }

  .selected {
    background-color: var(--rekki-dark);
    color: var(--rekki-light);
  }

  .round-left {
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
  }

  .round-right {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
  }

  .container:not(.inactive):not(.selected):not(.disabled):hover {
    background-color: var(--rekki-neutral-02);
    border-radius: 50%;
  }
</style>
